import type React from "react"
import { Navigate, useLocation } from "react-router-dom"
import { Box, CircularProgress, Alert } from "@mui/material"
import { useAuth } from "@/context/auth-context"

interface ProtectedRouteProps {
  children: React.ReactNode
  fallback?: React.ReactNode
  redirectTo?: string
}

export default function ProtectedRoute({ children, fallback, redirectTo = "/login" }: ProtectedRouteProps) {
  const { isAuthenticated, loading } = useAuth()
  const location = useLocation()

  if (loading) {
    return (
      fallback || (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "100vh",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <CircularProgress size={40} />
          <Box sx={{ color: "text.secondary", fontSize: "0.875rem" }}>Verificando autenticación...</Box>
        </Box>
      )
    )
  }

  // if (!isAuthenticated) {
  //   return (
  //     <Box
  //       sx={{
  //         display: "flex",
  //         justifyContent: "center",
  //         alignItems: "center",
  //         minHeight: "100vh",
  //         p: 2,
  //       }}
  //     >
  //       <Alert
  //         severity="error"
  //         sx={{ maxWidth: 400 }}
  //         action={
  //           <button
  //             onClick={() => window.location.reload()}
  //             style={{
  //               background: "none",
  //               border: "none",
  //               color: "inherit",
  //               textDecoration: "underline",
  //               cursor: "pointer",
  //             }}
  //           >
  //             Reintentar
  //           </button>
  //         }
  //       >
  //         Error al verificar la autenticación. Por favor, inicia sesión nuevamente.
  //       </Alert>
  //     </Box>
  //   )
  // }

  // if (!isAuthenticated) {
  //   return <Navigate to={redirectTo} state={{ from: location }} replace />
  // }

  return <>{children}</>
}
